// Axios
import { AxiosResponse } from "axios";
import { _axios_withoutHeaderToken } from "../../Base_Axios_Config/_axios_withoutHeaderToken";

// Axios

// Models
import { I_GettingAllocatedProcessesRequestData } from "../../../Models/sendingDataSchema";
import { I_AllocatedProcessData, I_Message } from "../../../Models/interfaces";
// Models

export const getAllAllocatedProcessesService = (_data: {
  userToken: string;
  _data: I_GettingAllocatedProcessesRequestData;
}): Promise<
  AxiosResponse<{
    error: number;
    messages: I_Message[];
    result: I_AllocatedProcessData;
  }>
> => {
  return _axios_withoutHeaderToken.get(
    `/allocated-processes?page=${_data._data.page}&size=${_data._data.size}&search=${_data._data.search}`
    // {
    //   headers: {
    //     Authorization: `Bearer ${_data.userToken}`,
    //   },
    // }
  );
};
